export interface ProductParameterValueFile {
    id: number
    url: string
}

export type ProductParameterValueConstraints = { [parameterKey: string]: string[] }[]

export interface ProductParameterValue {
    key: string
    label: string
    price: number
    priceMultiplier: number
    filesSelected?: File[]
    description?: string
    filesUploaded?: ProductParameterValueFile[]
    valueProvider?: ProductParameterValueProvider
    valueSelected?: ProductParameterValue
    constraints?: ProductParameterValueConstraints
    disabled?: boolean
}

export interface ProductParameterValueOfImageBrowser extends ProductParameterValue {
    imageUrl: string
}

export interface ProductParameterValueProvider {
    list?: ProductParameterValue[]
    range?: { min: number; max: number }
}

export type ProductParameterInput =
    | 'IntegerField'
    | 'ImageBrowser'
    | 'ButtonBrowser'

export interface ProductParameter {
    input: ProductParameterInput
    key: string
    label: string
    manual?: string
    valueProvider: ProductParameterValueProvider
    multiple: boolean
    disabled?: boolean
    changed?: boolean
}

export const productParametersMultiple = ['hardwares']

export async function productParameterValues(provider: ProductParameterValueProvider): Promise<ProductParameterValue[]> {
    if (typeof provider.list !== 'undefined')
        return provider.list
    if (typeof provider.range !== 'undefined') {
        const array = <ProductParameterValue[]>[]
        for (let i = provider.range.min; i <= provider.range.max; i++)
            array.push({ key: i.toString(), label: i.toString(), price: 0, priceMultiplier: 1 })
        return array
    }
    throw new Error(`Provider ${JSON.stringify(provider)} is unsupported.`)
}